import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Markdown from "markdown-to-jsx";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../LaunchComponent/LaunchDataDisplay.css";
import "./closureDataDisplay.css";
import ClosureSubmissionPop from "./closureSubmissionPop";
const ClosureDataDisplay = ({
  mailerParent,
  mailerChild,
  setIsClosureGenerationClicked,
  categoryNameClosure,
  handleReset,
  setIsClosureNavigatedToForm,
  setIsClosureMailGenerated,
  programNameClosure
}) => {
  const [open, setOpen] = useState(false);
  const isSubmitted = useSelector(state => state.model.isSubmitted);
  const isClosureLoaded = useSelector(state => state.closure.isClosureLoaded);
  const closureMail = useSelector(state => state.closure.closureMail);
  return <>
   <div className="data-display-new">
    <div className="result-container">
     <div className="result-wrap">
      <div className="result-content">
       {!isClosureLoaded && <Box display="flex" flexDirection="column" alignItems="center" sx={{
              height: "100%",
              justifyContent: "center"
            }}>
         <CircularProgress />
         <Typography variant="h6" marginTop={2}>
          Generating...
         </Typography>
        </Box>}
       {isClosureLoaded && closureMail != "" && <Stack spacing={2} sx={{
              padding: "0px",
              background: "white"
            }}>
         <style>
          {`
                    .highlight {
                        font-weight: bold;
                        color: black;
                    }
                `}
         </style>

         <div className="migrated-style-closuredatadisplay-98717a-1">
          <Markdown>{closureMail}</Markdown>
         </div>
        </Stack>}
      </div>
      <div className="result-btn-container">
       <div className="result-left">
        {isClosureLoaded && <Button variant="outlined" sx={{
                marginRight: "10px"
              }} disabled={isSubmitted ? true : false} onClick={() => {
                setOpen(true);
              }}>
          Submit For Approval
         </Button>}
       </div>
       <div className="result-right">
        <img src={process.env.PUBLIC_URL + "/Images/Dislikeicon.png"} />
        <img src={process.env.PUBLIC_URL + "/Images/Likeicon.png"} />
       </div>
      </div>
     </div>
     <div className="return-wrap">
      <p onClick={() => {
            setIsClosureGenerationClicked(false);
            // dispatch(handleTeaserLoading());
            setIsClosureNavigatedToForm(true);
            setIsClosureMailGenerated(null);
          }}>
       {"<"} Back
      </p>
     </div>
     <ClosureSubmissionPop open={open} setOpen={setOpen} mailerParent={mailerParent} mailerChild={mailerChild} modalResponse={closureMail} categoryNameClosure={categoryNameClosure} handleReset={handleReset} programNameClosure={programNameClosure} />
    </div>
   </div>
  </>;
};
export default ClosureDataDisplay;
